import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { initialUrl } from "../platform";
import { Store } from "./storage";

//Custom storage
const storage = Store("session");

//State
const State = {
  pageName: "Parks",
  errorMessage: "",
  loading: false,
  sortBy: "name-ascending",
  paths: {
    prefixes: ["http://localhost:3000/#/"],
    config: {
      screens: {
        Parks: {
          screens: {
            ParkView: "parks",
          },
        },
        Trails: {
          screens: {
            TrailsView: "trails",
          },
        },
        Events: {
          screens: {
            EventsView: "events",
          },
        },
        Settings: "settings",
        ParkDetails: "parkdetails",
      },
    },
    ...initialUrl,
  },
  webInstaller: {
    installed: false,
    promptWasShown: false,
    sessionSuppress: false,
  },
};

//Actions
const Actions = (_set, get) => {
  const set = _set;
  // set connection error
  const setPageName = (name) => {
    set({ pageName: name });
  };

  const setLoading = (isLoading) => {
    set({ loading: isLoading });
  };

  const setErrorMessage = (msg) => {
    set({ errorMessage: msg });
  };

  const setWebInstaller = (installerState) => {
    set({ webInstaller: { ...get().webInstaller, ...installerState } });
  };

  return {
    setPageName,
    setLoading,
    setErrorMessage,
    setWebInstaller,
  };
};
//Store
export default create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);
      return {
        ...State,
        setPageName: actions.setPageName,
        setLoading: actions.setLoading,
        setErrorMessage: actions.setErrorMessage,
        setWebInstaller: actions.setWebInstaller,
      };
    },
    {
      name: "app.global",
      storage: createJSONStorage(() => storage),
    }
  )
);
